import React from "react";
import { Navigate, Route, Routes } from 'react-router-dom'

import { ForgotPassword } from '../pages/Partner/ResetPassword/ForgotPassword.Page'
import { ForgotPasswordEnterCode } from '../pages/Partner/ResetPassword/ForgotPasswordEnterCode.Page'

/* ---------------------------------------------
   FORGOT PASSWORD ROUTER
--------------------------------------------- */
export const HomeRouter = () => {

  return (
      <Routes>
          {/* Forgot Password Home */}
          <Route path="/" element={<ForgotPassword />} />

          {/* Support /forgot-password */}
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Support /forgot-password/entercode */}
          <Route path="/forgot-password/entercode" element={<ForgotPasswordEnterCode />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
  );
}